import React from 'react';
import { useTranslator, useCurrentLanguage } from 'tradera-lang/translate';
import { isSwedishOrUndefined } from 'tradera-utils/languagecode';
import PaypalLogo from '@tradera/blueprint/theme/logos/paypal.svg?jsx';
import MastercardLogo from '@tradera/blueprint/theme/logos/mastercard_vertical.svg?jsx';
import MaestroLogo from '@tradera/blueprint/theme/logos/maestro_vertical.svg?jsx';
import VisaLogo from '@tradera/blueprint/theme/logos/visa.svg?jsx';
import GooglePayLogo from '@tradera/blueprint/theme/logos/google-pay.svg?jsx';
import ApplePayLogo from '@tradera/blueprint/theme/logos/apple-pay.svg?jsx';

export const FooterPartners = () => {
    const { t } = useTranslator();
    const { language } = useCurrentLanguage();

    const groupedPartners = [
        {
            type: 'payment1',
            partners: [
                {
                    logo: <PaypalLogo height={20} className="mr-1" />
                },
                {
                    logo: <VisaLogo height={16} className="mr-1" />
                }
            ]
        },
        {
            type: 'payment2',
            partners: [
                {
                    logo: <MaestroLogo height={30} className="mr-1" />
                },
                {
                    logo: <MastercardLogo height={30} />
                }
            ]
        },
        {
            type: 'payment3',
            partners: [
                {
                    logo: <GooglePayLogo height={20} className="mr-1" />
                },
                {
                    logo: <ApplePayLogo height={20} className="mr-1" />
                }
            ]
        },
        {
            type: 'shipping1',
            partners: [
                {
                    src: '/static/images/shipping/schenker.svg',
                    alt: 'DB Schenker logo'
                }
            ]
        },
        {
            type: 'shipping2',
            partners: [
                {
                    src: '/static/images/shipping/postnord.svg',
                    alt: 'Postnord logo'
                }
            ]
        }
    ];

    return !isSwedishOrUndefined(language) ? (
        <div className="site-footer__link-container col-6 col-md-3 mx-md-0 mb-3">
            <h4 className="text-styled">{t('footer_partners')}</h4>
            <ul className="plain-list">
                {groupedPartners.map(group => {
                    return (
                        <li key={group.type} className="mb-1">
                            {group.partners.map(partner => {
                                return partner.logo ? (
                                    partner.logo
                                ) : (
                                    <img
                                        src={partner.src}
                                        alt={partner.alt}
                                        className={'mr-1'}
                                        height={16}
                                    />
                                );
                            })}
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};
